<div
  class="header"
  [ngClass]="{
    'header-selected': this.selected && !this.closed,
    'header-default': !this.selected || this.closed,
    'error-border': this.hasError,
    'check-border': !this.hasError,
  }"
>
  <div [ngClass]="this.getCssForState()"></div>
  <div class="header-label">
    <mat-icon class="material-icons-outlined">
      {{ this.selected && !this.closed ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
    </mat-icon>
  </div>
  @if (this.completed || this.hasError) {
    <div class="header-label">
      <mat-icon [ngClass]="this.completed ? 'green-check' : 'red-error'">
        {{ getIcon() }}
      </mat-icon>
    </div>
  }
  @if (!this.hasError && !this.completed) {
    <span data-testid="step-number" class="header-label">{{ this.index + 1 + '.' }}</span>
  }
  <div data-testid="step-label" class="header-label">{{ this.label }}</div>
</div>
